import shallowEqual from 'shallowequal';
export default shallowEqual;